import { Component, OnDestroy } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize, takeWhile } from 'rxjs';

import { IReport, ReportsService } from '@app/core/reports';

@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.css'],
})
export class ReportDialogComponent implements OnDestroy {
  public form: FormGroup;
  public saving: boolean;
  public units: string[];

  private report: IReport;
  private destroyed: boolean;

  constructor(
    cfg: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private service: ReportsService
  ) {
    this.units = ['px', '%'];

    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      url: new FormControl('', [Validators.required]),
      width: new FormControl('', [Validators.required]),
      widthUnit: new FormControl('px'),
      height: new FormControl('', [Validators.required]),
      heightUnit: new FormControl('px'),
      categories: new FormArray([]),
    });

    if (cfg.data?.report) {
      this.report = cfg.data.report;
      console.log('ReportDialogComponent', this.report);
      this.report.categories.forEach((category) => {
        console.log('Adding category', category);
        this.categories.push(new FormControl(category.name));
      });
      this.form.patchValue(this.report);
      this.form.patchValue({
        categories: this.report.categories.map((c) => c.name),
      })
    }
  }

  public saveChanges(): void {
    this.form.markAllAsTouched();

    Object.keys(this.form.controls).forEach((key) => {
      this.form.get(key).markAsDirty();
    });

    if (!this.form.valid) {
      return;
    }

    this.saving = true;

    const op = !this.report
      ? this.service.createReport({ ...this.form.value })
      : this.service.updateReport({ ...this.report, ...this.form.value });

    op.pipe(
      takeWhile(() => !this.destroyed),
      finalize(() => (this.saving = false))
    ).subscribe((report) => {
      this.dialogRef.close(report);
    });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }

  get categories(): FormArray {
    return this.form.get('categories') as FormArray;
  }

  addCategory(value: string = '') {
    this.categories.push(new FormControl(value));
  }

  removeCategory(index: number) {
    this.categories.removeAt(index);
  }

  get categoryControls(): FormControl[] {
    return this.categories.controls as FormControl[];
  }
}
